import React from 'react'

function TenderTextGsbox() {
  return (
    <embed src="\pdfs\EA1.2_gs-box_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextGsbox